import { render, staticRenderFns } from "./edit-related.vue?vue&type=template&id=555416c1&scoped=true&"
import script from "./edit-related.vue?vue&type=script&lang=js&"
export * from "./edit-related.vue?vue&type=script&lang=js&"
import style0 from "./edit-related.vue?vue&type=style&index=0&id=555416c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555416c1",
  null
  
)

export default component.exports